import NotFound from "../../pages/NotFound";
import Home from "../../pages/Home";
import Signup from "../../pages/Signup"
import Login from "../../pages/Login";
import Profile from "../../pages/Profile"
import Dimensions from "../../pages/Dimensions";
import ResetPassword from "../../pages/ResetPassword";
import Dashboard from "../../pages/Dashboard";
const Pages = { NotFound,Home,Signup ,Login,Profile,Dimensions,ResetPassword,Dashboard};
export default Pages;
